
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 7a4 4 0 014 4v10a4 4 0 01-4 4H8a4 4 0 01-4-4V11a4 4 0 014-4h16zm-5.838 3.055a.902.902 0 00-1.155.538L13.299 20.79a.902.902 0 001.693.617L18.7 11.21a.901.901 0 00-.538-1.155zm-5.178 3.05a.902.902 0 00-1.195-.17l-.074.055-2.78 2.318a.903.903 0 000 1.384l2.78 2.319.074.054a.901.901 0 001.148-1.378l-.068-.062L10.918 16l1.951-1.625a.902.902 0 00.115-1.27zm7.227-.17a.902.902 0 00-1.147 1.377l.068.063L21.082 16l-1.95 1.625a.902.902 0 001.079 1.44l.074-.054 2.781-2.319.073-.067a.903.903 0 000-1.25l-.073-.067-2.78-2.318-.075-.055z","fill":"#525F7F"}})])
          )
        }
      }
    